import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function EntryLevelResumeExamples() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Entry Level Resume Examples (2026 Guide)"
        description="See real entry level resume examples. Learn how to write a resume for your first job with no experience and get hired faster."
        canonical="https://employpilot.com/entry-level-resume-examples"
      />

      <h1>Entry Level Resume Examples (First Job Guide)</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Writing your first resume can feel overwhelming — but with the right structure,
        you can stand out even with little or no experience.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Build Your Resume Now
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Entry Level Resume Example</h2>

      <div style={{ background: "#f9f9f9", padding: "20px", borderRadius: "8px" }}>
        <p><strong>Jane Smith</strong></p>
        <p>Motivated individual seeking an entry-level position to develop skills and grow professionally.</p>

        <p><strong>Skills:</strong></p>
        <ul>
          <li>Customer Service</li>
          <li>Communication</li>
          <li>Teamwork</li>
        </ul>

        <p><strong>Education:</strong></p>
        <p>High School Diploma / College Student</p>
      </div>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What to Include</h2>

      <ul>
        <li>✔ Skills section (VERY important)</li>
        <li>✔ Education</li>
        <li>✔ Projects or volunteer work</li>
        <li>✔ Certifications (if available)</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Tips for First-Time Job Seekers</h2>

      <ul>
        <li>✔ Keep it to one page</li>
        <li>✔ Focus on potential, not history</li>
        <li>✔ Use action words</li>
        <li>✔ Tailor for each job</li>
      </ul>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        No experience?{" "}
        <Link to="/resume-no-experience">
          Learn how to write your first resume
        </Link>
      </p>

      <p>
        Need skills?{" "}
        <Link to="/resume-skills">
          See the best skills to include
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Create Your First Resume Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>

      {/* FAQ */}
      <h2 style={{ marginTop: "60px" }}>FAQs</h2>

      <h3>What if I’ve never had a job?</h3>
      <p>Focus on skills, school, and projects.</p>

      <h3>How long should it be?</h3>
      <p>One page is ideal.</p>

      <h3>Can I still get hired?</h3>
      <p>Yes — entry-level jobs expect beginners.</p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default EntryLevelResumeExamples;